import { FETCH_STATUSES, FETCH_STATUSES_SUCCESS, FETCH_STATUSES_FAILURE } from './types'

export const fetchStatuses = (accessToken) => ({
  type: FETCH_STATUSES,
  payload: { accessToken },
})

export const fetchStatusesSuccess = (data) => ({
  type: FETCH_STATUSES_SUCCESS,
  payload: data,
})

export const fetchStatusesFailure = (error) => ({
  type: FETCH_STATUSES_FAILURE,
  payload: error,
})
